import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { AgentLookupDto } from 'src/core/models/agent/agent-lookup.dto';
import { AgentService } from 'src/core/services/agent/agent.service';
import { QueueDto } from '../models/queue.dto';
import { HoldMusicUploadResultDto } from '../models/hold-music-upload-result.dto';

@Injectable({
  providedIn: 'root',
})
export class QueueService {
  private readonly agentService = inject(AgentService);
  private readonly http = inject(HttpClient);

  getAgentLookup(): Observable<AgentLookupDto[]> {
    return this.agentService.getAgentLookup();
  }

  uploadHoldMusic(queueId: number, file: File): Observable<HoldMusicUploadResultDto> {
    const formData = new FormData();
    formData.append('file', file, file.name);

    return this.http.post<HoldMusicUploadResultDto>(
      `${environment.apis.default.url}/${QueueDto.apiUrl}/${queueId}/hold-music`,
      formData,
    );
  }
}
